<template>
  <div class="applications-links-apps">
    <el-button
      :size="size"
      icon="mdi mdi-view-grid-plus"
      type="info"
      @click="visible = true"
    >
      <slot />
    </el-button>

    <el-dialog :show-close="false" :visible.sync="visible">
      <Filters placeholder="Search by application name, domain or IP" />

      <el-table
        :data="data"
        :default-sort="defaultSort"
        size="small"
      >
        <el-table-column width="30px">
          <template slot-scope="scope">
            <img :src="bundleImage(scope.row.bundleId)" />
          </template>
        </el-table-column>

        <el-table-column label="Name" prop="alias" sortable />

        <el-table-column label="Server" sortable>
          <template slot-scope="scope">
            <img :src="regionFlag(instancePlan(scope.row.instanceId))" class="flag" />
            {{ instanceName(scope.row.instanceId) }}
          </template>
        </el-table-column>

        <el-table-column align="right" width="120px">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.id === applicationId"
              type="primary"
              :disable-transitions="true"
            >
              <i class="el-icon-check" /> Selected
            </el-tag>

            <el-button
              v-else
              type="primary"
              size="small"
              @click="applicationId = scope.row.id"
            >
              Choose
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer">
        <el-button
          type="default"
          size="large"
          @click="visible = false"
        >
          Cancel
        </el-button>

        <el-button
          type="primary"
          size="large"
          :disabled="!applicationId"
          @click.prevent="link"
        >
          {{ label }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Filters from '../../Filters'

export default {
  props: {
    application: {
      type: Object,
      default: () => ({})
    },
    links: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: 'medium'
    }
  },
  components: {
    Filters
  },
  data () {
    return {
      visible: false,
      applicationId: null,
      defaultSort: {
        prop: 'created',
        order: 'descending'
      }
    }
  },
  computed: {
    label () {
      const application = this.applications.find((a) => a.id === this.applicationId)
      return 'Link' + (application ? ' ' + application.alias : '')
    },
    data () {
      return this.applications
        .filter((a) => a.state !== 'stopped' &&
          a.id !== this.application.id &&
          !this.links.find((l) => l.id === a.id))
        .sort((a, b) => b.created - a.created)
    },
    ...mapState(['applications', 'instances'])
  },
  methods: {
    instanceName (instanceId) {
      const instance = this.instances.find((i) => i.id === instanceId)
      return instance ? instance.name : ''
    },
    instancePlan (instanceId) {
      const instance = this.instances.find((i) => i.id === instanceId)
      return instance ? instance.planId : ''
    },
    link () {
      this.$store.dispatch('linkApplication', {
        id: this.application.id,
        linkId: this.applicationId
      }).then(() => {
        const application = this.applications.find((a) => a.id === this.applicationId)
        this.$emit('update:links', [...this.links, application])
        this.visible = false
      }).catch(() => {})
    }
  },
  watch: {
    visible () {
      this.applicationId = null
    }
  }
}
</script>

<style lang="scss" scoped>
  img {
    max-width: 20px;
    float: left;
  }
  .flag {
    padding-top: 5px;
    margin-right: 5px;
  }
</style>

<style lang="scss">
  .applications-links-apps {
    > .el-button {
      margin-top: 10px;
    }
    .el-button + .el-button {
      margin-left: 10px !important;
    }
    .el-dialog {
      min-width: 650px;
    }
  }
</style>
